module.exports = __webpack_public_path__ + "img/help-content-1.8c3397b1.png";